export const formatDoj = (ymd) =>
    ymd ? new Date(`${ymd}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "";

export const tenureOf = (ymd) => {
    if (!ymd) return "";
    const s = new Date(`${ymd}T00:00:00`);
    const n = new Date();
    let months = (n.getFullYear() - s.getFullYear()) * 12 + (n.getMonth() - s.getMonth());
    if (n.getDate() < s.getDate()) months -= 1;
    if (months < 1) return "new joiner";
    const y = Math.floor(months / 12), m = months % 12;
    return [y && `${y}y`, m && `${m}m`].filter(Boolean).join(" ");
};

export const todayLocal = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
